import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Input } from 'reactstrap'
import { api } from '../../api/api'
import { properties } from '../../constants/Propertise'
// import history from '../../history'
import { history } from '../../history'
import { login } from '../../Reducers/Login/NewLoginReducer'
import AlertMessages from '../AlertMessages'
import InlineError from '../InlineError'
import Overlay from '../Overlay'
// import CountdownTimer from './CountdownTimer'

class LoginOtp extends Component {
    constructor(props) {
        super(props)
        this.state = {
            otp: '',
            errors: {},
            isPending: true,
            isError: false,
            isSucess: false,

            time: {},
            seconds: 30,

            showCounter: false,
            ThirtySeconds_IN_MS: 30 * 1000,
            NOW_IN_MS: new Date().getTime(),
            // afterThirtySeconds: this.state.NOW_IN_MS + this.state.ThirtySeconds_IN_MS,
            afterThirtySeconds: new Date().getTime() + 30000,
            disableResendOTPButton: false
        }

        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }

    handleChange = (event) => {
        let value = event.target.value
        this.setState({
            ...this.state.otp,
            otp: value
        })
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const errors = this.validate(this.state);
        this.setState({ errors });
        if (Object.keys(errors).length === 0) {
            this.props.login(this.props.userDetails, this.state.otp)
        }
    }

    validate = data => {
        const errors = {};
        if (!data.otp) errors.otp = properties.otpReqText;

        return errors;
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.userToken !== this.props.userToken) {
            if (this.props.isLoginSuccess) {
                history.push(`${process.env.PUBLIC_URL}/welcome`)
            }
        }
        if (prevProps.loginError !== this.props.loginError) {
            if (this.props.loginError === true) {
                this.setState({
                    errors: {
                        ...this.state.errors,
                        otp: 'Invalid OTP'
                    }
                })
                setTimeout(() => {
                    this.setState({
                        errors: {},
                        otp: ''
                    })
                }, 1000)
            }
        }

        if (prevState.disableResendOTPButton !== this.state.disableResendOTPButton) {
            if (this.state.disableResendOTPButton) {
                this.restartTimer()
            }
        }
    }

    closeInPageAlertModel = () => {
        this.setState({
            showInPageAlertModel: false
        })
    }

    componentDidMount() {
        this.startTimer();
        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({ time: timeLeftVar });
    }

    secondsToTime(secs) {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            h: hours,
            m: minutes,
            s: seconds
        }

        return obj;
    }

    startTimer() {
        if (this.timer === 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds
        });

        // Check if we're at zero.
        if (seconds === 0) {
            clearInterval(this.timer);
            // this.props.showResendOpt();
            this.setState({
                disableResendOTPButton: false
            })
        }
    }

    restartTimer = () => {
        this.setState({
            seconds: this.state.seconds
        }, () => {
            this.timer = 0;
            this.startTimer();
        });
    }

    stopTimer = () => {
        clearInterval(this.timer);
        this.setState({ seconds: 0 }, () => {
            this.timer = 0;
        });
    }

    handleResendOTP = () => {
        let resendOtpUrl = `${process.env.REACT_APP_USERMANAGEMENT_API_URL}OTP/v1/emailOTP`
        // let resendOtpUrl = `${process.env.REACT_APP_API_URL}OTP/v1/emailOTP`
        this.setState({
            disableResendOTPButton: true,
            seconds: 30
        })
        const resendOtpReqBody = {
            username: this.props.userDetails.username.toLowerCase()
        }
        api
            .post(resendOtpUrl, resendOtpReqBody)
            .then(resendOtpResult => {
                if (resendOtpResult.data !== "undefined") {
                    this.setState({
                        inpageLoadingError: false,
                        inpageLoadingPending: false,
                        inpageLoadingSucess: true,
                        showInPageAlertModel: true,
                        message: resendOtpResult.data,
                    })

                    setTimeout(() => {
                        if (this.state.inpageLoadingSucess === true) {
                            this.setState({
                                showInPageAlertModel: false
                            })
                        }
                    }, 1000)

                } else {
                    this.setState({
                        inpageLoadingError: true,
                        inpageLoadingPending: false,
                        inpageLoadingSucess: false,
                        showInPageAlertModel: true,
                        message: properties.globalErrorMessage,
                    })
                }
            })
            .catch(error => {
                this.setState({
                    inpageLoadingError: true,
                    inpageLoadingPending: false,
                    inpageLoadingSucess: false,
                    showInPageAlertModel: true,
                    message: properties.globalErrorMessage,
                })
            })
    }

    render() {
        return (
            <Fragment>

                <div className="mb-3">
                    {
                        (this.state.inpageLoadingPending === true) &&
                        <div className="form-row">
                            <div className="col-md-12 mb-3">
                                <div
                                    className="alert alert-info alert-dismissible"
                                    role="alert"
                                    style={{ textAlign: "center" }}
                                >
                                    {properties.pleaseWaitText}
                                </div>
                            </div>
                        </div>
                    }
                    {
                        (this.state.inpageLoadingError === true) &&
                        <div className="form-row">
                            <div className="col-md-12 mb-3">
                                <div
                                    className="alert alert-danger alert-dismissible"
                                    role="alert"
                                    style={{ textAlign: "center" }}
                                >
                                    {properties.globalUserErrorMessage}
                                </div>
                            </div>
                        </div>
                    }

                    <div className="form-row">
                        <div className="col-md-12 mb-3">
                            {properties.userAuthenticationText}
                        </div>
                    </div>


                    <form
                        onSubmit={this.handleSubmit.bind(this)}
                        autoComplete="off"
                    >
                        <div className="form-row">
                            <div className="col-md-12 mb-3">
                                <label className="feildName">
                                    {properties.Otptext}
                                    <span className="required" >*</span>:
                                </label>
                                <Input
                                    type="text"
                                    name="otp"
                                    value={this.state.otp}
                                    onChange={this.handleChange.bind(this)}
                                    valid={
                                        (
                                            this.state.errors.otp === undefined &&
                                            this.state.otp !== '' &&
                                            this.state.isValid === true
                                        ) ? true : false}
                                    invalid={this.state.errors.otp !== undefined ? true : false}
                                />
                                {
                                    this.state.errors.otp &&
                                    <InlineError text={this.state.errors.otp} />
                                }
                            </div>
                        </div>

                        {
                            this.state.seconds !== 0 ?
                                <div className='form-row'>
                                    <div className="col-md-12 text-danger">
                                        {properties.linkRegenerate}
                                        {this.state.time.s} {properties.secondsText}
                                    </div>
                                </div> : null
                        }

                    </form>
                </div>
                <div className="divider" />
                <div>
                    <button
                        className="btn btn-primary pull-right"
                        type="submit"
                        onClick={this.handleSubmit}
                    >
                        {properties.submitButtonText}
                    </button>
                </div>

                {/* 
                {
                    (this.state.seconds == 0) ?
                        <div>
                            <button
                                className="btn btn-primary pull-left"
                                type="submit"
                                onClick={this.handleResendOTP}
                            >
                                {properties.resendOtpButtonText}
                            </button>
                        </div> :
                        <div>
                            <button
                                className="btn btn-primary pull-left"
                                type="submit"
                                disabled
                            >
                                {properties.resendOtpButtonText} ({this.state.time.s} Sec)
                                {properties.resendOtpButtonText} (<CountdownTimer setState={this.setState()} targetDate={this.state.afterThirtySeconds} /> Sec)
                            </button>
                        </div>
                } */}

                <div>
                    <button
                        className="btn btn-primary pull-left"
                        type="submit"
                        onClick={this.handleResendOTP}
                        disabled={this.state.seconds === 0 ? false : true}
                    >
                        {this.state.seconds === 0 ? (`${properties.resendOtpButtonText}`) : (`${properties.resendOtpButtonText} (${this.state.time.s} sec)`)}
                    </button>
                </div>

                <Overlay
                    openOverlay={this.state.showInPageAlertModel}
                    closeOverlay={this.closeInPageAlertModel}
                    className="alertData"
                >
                    <AlertMessages
                        isSucess={this.state.inpageLoadingSucess}
                        isPending={this.state.inpageLoadingPending}
                        apiError={this.state.inpageLoadingError}
                        showAlert={this.state.showInPageAlertModel}
                        closeAlert={this.closeInPageAlertModel}
                        message={this.state.message}
                    />
                </Overlay>

            </Fragment>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        isLoginSuccess: state.loginData.isLoginSuccess,
        isLoginPending: state.loginData.isLoginPending,
        loginError: state.loginData.loginError,
        authDone: state.loginData.authDone,
        userToken: state.loginData.userToken,
        apiError: state.loginData.apiError,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        login: (loginData, otp) => dispatch(login(loginData, otp))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginOtp);